// COMPONENTS
import CurrencyHelpers from 'lib/helpers/CurrencyHelpers/index';

const getInvoiceProps = ({ client, invoice, organization }) => {
  let currencySymbol = CurrencyHelpers.getCurrencySymbol(invoice.currency);

  return {
    clientId: client._id,
    client,
    organization,
    currencySymbol,
    invoice: {
      ...invoice,
      client,
      organization,
    },
  };
};

export default getInvoiceProps;



// WEBPACK FOOTER //
// ./src/lib/helpers/PDFHelpers/getInvoiceProps.js